module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: {
      'language-selection__wrapper': !_vm.single
    }
  }, [(!_vm.single) ? _c('h4', {
    staticClass: "language-selection__title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('SELECT_YOUR_PATIENT_ACCOUNT_LANGUAGE')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "el-col-xs-12 el-col-sm-12 mr-3"
  }, [_c('el-select', {
    staticClass: "xs6 flex-select mb-3",
    attrs: {
      "placeholder": _vm.$t('SELECT')
    },
    model: {
      value: (_vm.lngSelected),
      callback: function($$v) {
        _vm.lngSelected = $$v
      },
      expression: "lngSelected"
    }
  }, _vm._l((_vm.interfaceLanguages), function(lang) {
    return _c('el-option', {
      key: lang,
      attrs: {
        "label": _vm.$t('NAME_NATIVE', lang),
        "value": lang
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "el-col-xs-12 el-col-sm-6"
  }, [_c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--big app-btn-primary",
    on: {
      "click": _vm.selectLanguage
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('APPLY')) + "\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60bcff9e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/language-selection.vue
// module id = 1210
// module chunks = 0